'use strict';exports.__esModule = true;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _set = require('lodash/set');var _set2 = _interopRequireDefault(_set);
var _helpers = require('@turf/helpers');
var _routerAdapter = require('../helpers/routerAdapter');
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// Map client path to server path ([clientPath, serverPath])
var paramsMapper = [
['name', 'name'],
['location', 'section'],
['optionType', 'search_option'],
['params.types', 'property_types'],
['params.price.minPrice', 'min_price'],
['params.price.maxPrice', 'max_price'],
['params.rooms', 'rooms'],
['params.commodities', 'commodities'],
['params.photos', 'has_photos'],
['params.elevator', 'has_elevator'],
['params.balcony', 'has_balcony'],
['params.floor.min', 'min_floor'],
['params.floor.max', 'max_floor'],
['params.area.min', 'min_area'],
['params.area.max', 'max_area'],
['params.constructionYear.min', 'min_construction_year'],
['params.constructionYear.max', 'max_construction_year'],
['params.bathrooms', 'bathrooms'],
['params.toilets', 'toilets'],
['params.notLastFloor', 'not_last_floor'],
['params.parkingSpot', 'has_parking'],
['locationSearch.en.city_name', 'city'],
['locationSearch.en.neighborhood', 'neighborhood'],
['locationSearch.en.street_name', 'street'],
['locationSearch.en.house_number', 'house'],
['locationSearch.zoom', 'map.zoom'],
['drawn', 'drawn']];


var generateRequestBody = function generateRequestBody(data) {return paramsMapper.reduce(function (acc, _ref) {var clientPath = _ref[0],serverPath = _ref[1];
    var value = (0, _get2.default)(data, clientPath);

    if (value instanceof Array && value.includes('all')) {
      var idx = value.indexOf('all');
      value.splice(idx, 1);
    }

    if (value) {
      return (0, _set2.default)(acc, serverPath, value);
    }

    return acc;
  }, {});};

var generateRouteDataObject = function generateRouteDataObject(data) {return paramsMapper.reduce(function (acc, _ref2) {var clientPath = _ref2[0],serverPath = _ref2[1];
    var value = (0, _get2.default)(data, serverPath);

    if (value) {
      return (0, _set2.default)(acc, clientPath, value);
    }

    return acc;
  }, { locationSearch: Object.assign({}, _constants.clearFiltersInitialValues.locationSearch) });};

var generateMapParams = function generateMapParams(_ref3) {var _ref3$location = _ref3.location,location = _ref3$location === undefined ? {} : _ref3$location,_ref3$map = _ref3.map,map = _ref3$map === undefined ? {} : _ref3$map,zoom = _ref3.zoom;return {
    center: Object.assign({}, location),
    topright: Object.assign({}, map.topright),
    zoom: zoom || _constants.clearFiltersInitialValues.locationSearch.zoom };};


var requestUrl = '/property-searches';exports.default =

{
  create: function create(data, token) {
    return _axios2.default.post(requestUrl, data, { headers: { access_token: token } });
  },
  load: function load(token) {
    return _axios2.default.get(requestUrl, { headers: { access_token: token } });
  },
  delete: function _delete(id, token) {
    return _axios2.default.delete(requestUrl + '/' + id, { headers: { access_token: token } });
  },
  generateRequestData: function generateRequestData(data) {
    var requestBody = generateRequestBody(data);
    requestBody.section = requestBody.section === 'homes' ? 'residence' : requestBody.section;

    if (data.locationSearch) {
      requestBody.map = generateMapParams(data.locationSearch);
    }

    if (data.drawn && data.drawn.geometry) {
      requestBody.drawn = (0, _helpers.polygons)(data.drawn.geometry.coordinates);
    }

    return requestBody;
  },
  generateRouteData: function generateRouteData(data) {
    var routeData = generateRouteDataObject(data);
    routeData.name = data.name;
    routeData.id = data.id;
    routeData.createdAt = data.created_at;
    routeData.location = !routeData.location || routeData.location === 'residence' ?
    'homes' :
    routeData.location;

    if (!routeData.optionType) {
      routeData.optionType = _constants.defaultOptionType;
    }

    if (data.map) {
      routeData.locationSearch.map = Object.assign({},

      data.map);


      if (data.map.center) {
        routeData.locationSearch.location = data.map.center;
      }
    }

    return routeData;
  },
  parseResponseToUrl: function parseResponseToUrl(data) {
    return (0, _routerAdapter.createUrl)(data);
  } };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/services/PropertySearchService.js
// module id = 1283
// module chunks = 0